var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Portal', {
    attrs: {
      "to": _vm.highestOrder ? 'highest' : 'popup',
      "order": _vm.order
    }
  }, [_c('transition', {
    attrs: {
      "name": "popup",
      "enter-active-class": _vm.openTransitionClass,
      "leave-active-class": _vm.closeTransitionClass
    }
  }, [_vm.isActive ? _c('div', {
    staticClass: "popup",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleOverlayClick.apply(null, arguments);
      }
    }
  }, [_vm._t("default")], 2) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }